import { IMarkerPopup } from "@components/blocks/map/markerPopup/MarkerPopup";
import { OnSelect } from "@lib/utils/types/filters/OnSelect";
import { createContext, ReactNode, useContext, useState } from "react";

export interface IMapContext {
  markerPopup: Omit<IMarkerPopup, "onClose"> | null;
  recentlyChosenFilter: OnSelect | null;
  setMarkerPopup: (marker: Omit<IMarkerPopup, "onClose"> | null) => void;
  setFilter: (filter: OnSelect | null) => void;
  clearMarkerPopup: () => void;
}

export interface IMapProvider {
  children: ReactNode;
}

export const mapContext = createContext<IMapContext | undefined>(undefined);

const MapContextProvider = mapContext.Provider;

export const MapProvider = ({ children }: IMapProvider) => {
  const [markerPopup, setMarker] = useState<Omit<
    IMarkerPopup,
    "onClose"
  > | null>(null);
  const [recentlyChosenFilter, setRecentlyChosenFilter] =
    useState<OnSelect | null>(null);

  const setMarkerPopup = (marker: Omit<IMarkerPopup, "onClose"> | null) => {
    setMarker(marker);
  };

  const clearMarkerPopup = () => {
    setMarker(null);
  };

  const setFilter = (filter: OnSelect | null) => {
    setRecentlyChosenFilter(filter);
  };

  return (
    <MapContextProvider
      value={{
        markerPopup,
        recentlyChosenFilter,
        setMarkerPopup,
        clearMarkerPopup,
        setFilter,
      }}
    >
      {children}
    </MapContextProvider>
  );
};

export const useMapContext = () => {
  const context = useContext(mapContext);

  if (!context) {
    throw new Error("useMapContext cannot be used outside of MapProvider");
  }

  return context;
};
